import React, { useEffect, useState } from "react";
import "../Home/homeScreen.css";
import image1 from "../../images/ProfileNew450px.png";
import image2 from "../../images/TeamNew450px.png";
import image4 from "../../images/InfoNew450px.png";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { Offcanvas } from "react-bootstrap";
import { format2 } from "../../utils/money";

// function HomeScreen() {
//   const navigate = useNavigate();
//   const fullName = localStorage.getItem("fullName") || "User"; // Default to "User" if not found
//   const credits = localStorage.getItem("credits") || 0; // Default to 0 if not found

//   // If needed, you can ensure the state is initialized on first render using useEffect
//   useEffect(() => {
//     console.log("Component Mounted");
//   }, []); // Empty array to run only on the first render

//   return (
//     <div className="container">
//       <div className="card" style={{ background: "none" }}>
//         <div className="card-header">
//           <div className="d-flex">
//             <div className="left-section">{fullName}</div>
//             <div className="right-section">
//               <h3 className="h3">Credit</h3>
//               <p>
//                 Available: <span>{credits}</span>
//               </p>
//               <p>
//                 In-Play Value: <span>0</span>
//               </p>
//               <p style={{ paddingTop: '5px' }}>
//                 Overall +/- :<span>0</span>
//               </p>
//             </div>
//           </div>
//           <div className="d-flex">
//             <div className="left-section">Home</div>
//             <div className="right-market">
//               <button className="button" onClick={() => navigate("/market")}>
//                 View Market
//               </button>
//             </div>
//           </div>
//         </div>
//         <div className="card-bodyyy">
//           <h3 className="h3">What Would You Like to Do?</h3>

//           <div className="body-div">
//             <div className="d-flex">
//               <div className="icon" onClick={() => navigate("/profile")}>
//                 <i className="fa-regular fa-user"></i>
//                 <h2>My Profile</h2>
//               </div>
//               <div className="icon" onClick={() => navigate("/myteam")}>
//                 <i className="fa-solid fa-people-group"></i>
//                 <h2>My Team</h2>
//               </div>
//             </div>
//             <div className="d-flex">
//               <div className="icon" onClick={() => navigate("/market")}>
//                 <img src={image1} className="market-img" alt="Market" />
//                 <h2>The Market</h2>
//               </div>
//               <div className="icon" onClick={() => navigate("/faq")}>
//                 <i className="fa-solid fa-book-open"></i>
//                 <h2>User Guide</h2>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="card-footer">
//           <div className="footer">
//             <div className="footer-first">
//               <button className="btn1">Start Building Your Team</button>
//             </div>
//             <div className="d-flex">
//               <div className="first">
//                 <h4>0/8</h4>
//                 <p className="p1">Selections</p>
//                 <p className="p1">0.00 spent</p>
//               </div>
//               <div className="second">
//                 <div className="circle1"></div>
//                 <div className="circle1"></div>
//                 <div className="circle1"></div>
//                 <div className="circle1"></div>
//                 <div className="circle1"></div>
//                 <div className="circle1"></div>
//                 <div className="circle1"></div>
//                 <div className="circle1"></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// function HomeScreen() {
//   const navigate = useNavigate();
//   const [userData, setUserData] = useState({ fullName: "User", credits: 0 });

//   useEffect(() => {
//     // Get the user token from local storage
//     const token = localStorage.getItem("user_token");

//     if (token) {
//       try {
//         // Decode the token to get the user ID
//         const decodedToken = jwtDecode(token);
//         console.log("Decoded Token:", decodedToken); // Debugging line
//         const userId = decodedToken._id; // Assuming _id is directly in the decoded token

//         if (userId) {
//           console.log("User ID:", userId); // Debugging line
//           // Fetch user list from the API
//           axios.get("https://toptennis.io/api/users/userList", {
//             headers: { user_token: token }
//           })
//           .then(response => {
//             console.log("API Response:", response.data); // Debugging line

//             // Access userDetails from the response
//             const userDetails = response.data.userDetails; // Accessing userDetails

//             // Check if userDetails is an array
//             if (Array.isArray(userDetails)) {
//               // Check if the user ID matches
//               const matchedUser = userDetails.find(user => user._id.toString() === userId.toString());
//               console.log("Matched User:", matchedUser); // Debugging line

//               if (matchedUser) {
//                 // If there's a match, extract name and credits
//                 const { name, credits } = matchedUser;
//                 setUserData({ fullName: name, credits });
//               } else {
//                 console.error("No user found with the matching ID.");
//               }
//             } else {
//               console.error("userDetails is not an array:", userDetails);
//             }
//           })
//           .catch(error => {
//             console.error("Error fetching user data", error);
//           });
//         } else {
//           console.error("User ID is not found in decoded token");
//         }
//       } catch (error) {
//         console.error("Failed to decode token", error);
//       }
//     } else {
//       console.error("Token not found in localStorage");
//     }

//     console.log("Component Mounted");
//   }, []); // Empty array to run only on the first render

//   return (
//     <div className="container">
//       <div className="card" style={{ background: "none" }}>
//         <div className="card-header">
//           <div className="d-flex">
//             <div className="left-section">{userData.fullName}</div>
//             <div className="right-section">
//               <h3 className="h3">Credit</h3>
//               <p>
//                 Available: <span>{userData.credits}</span>
//               </p>
//               <p>
//                 In-Play Value: <span>0</span>
//               </p>
//               <p style={{ paddingTop: "5px" }}>
//                 Overall +/- :<span>0</span>
//               </p>
//             </div>
//           </div>
//           <div className="d-flex">
//             <div className="left-section">Home</div>
//             <div className="right-market">
//               <button className="button" onClick={() => navigate("/market")}>
//                 View Market
//               </button>
//             </div>
//           </div>
//         </div>
//         <div className="card-bodyyy">
//           <h3 className="h3">What Would You Like to Do?</h3>

//           <div className="body-div">
//             <div className="d-flex">
//               <div className="icon" onClick={() => navigate("/profile")}>
//                 <i className="fa-regular fa-user"></i>
//                 <h2>My Profile</h2>
//               </div>
//               <div className="icon" onClick={() => navigate("/myteam")}>
//                 <i className="fa-solid fa-people-group"></i>
//                 <h2>My Team</h2>
//               </div>
//             </div>
//             <div className="d-flex">
//               <div className="icon" onClick={() => navigate("/market")}>
//                 <img src={image1} className="market-img" alt="Market" />
//                 <h2>The Market</h2>
//               </div>
//               <div className="icon" onClick={() => navigate("/faq")}>
//                 <i className="fa-solid fa-book-open"></i>
//                 <h2>User Guide</h2>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="card-footer">
//           <div className="footer">
//             <div className="footer-first">
//               <button className="btn1">Start Building Your Team</button>
//             </div>
//             <div className="d-flex">
//               <div className="first">
//                 <h4>0/8</h4>
//                 <p className="p1">Selections</p>
//                 <p className="p1">0.00 spent</p>
//               </div>
//               <div className="second">
//                 <div className="circle1"></div>
//                 <div className="circle1"></div>
//                 <div className="circle1"></div>
//                 <div className="circle1"></div>
//                 <div className="circle1"></div>
//                 <div className="circle1"></div>
//                 <div className="circle1"></div>
//                 <div className="circle1"></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

function HomeScreen() {
  const navigate = useNavigate();
  const [userData, setUserData] = useState({ fullName: "User", credits: 0 });

  const [isPageRefreshed, setIsPageRefreshed] = useState(false);
  const [players, setPlayers] = useState([]);
  const [totalSpent, setTotalSpent] = useState(0);
  const [teamName, setTeamName] = useState("");
  const [userName, setUserName] = useState("");
  const [inPlayValue, setInPlayValue] = useState(0);
  const [credits, setCredits] = useState(0);
  const [withdrawableCredits, setWithdrawableCredits] = useState(0);
  const [searchTerm, setSearchTerm] = useState(""); // State for search term
  const [buyPlayer, setBuyPlayer] = useState();
  const [teamProfileImage, setTeamProfileImage] = useState("");
  const [filteredPlayers, setFilteredPlayers] = useState([]);
  const [teamPlayers, setTeamPlayers] = useState([]);
  const [isMarketFrozen, setIsMarketFrozen] = useState(false);
  const [freezeMessage, setFreezeMessage] = useState("");
  const [differenceValue, setDifferenceValue] = useState(0);
  const [playerval, setplayerval] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [totalDeposit, setTotalDeposit] = useState(0);

  const handleSubscribe = async () => {
    if (!email) {
      setMessage("Please enter a valid email.");
      return;
    }

    try {
      const response = await fetch(
        "https://api.convertkit.com/v3/forms/7878458/subscribe",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            api_key: "3bkwOyREXJsvpFPZ5iUAAw",
            email: email,
          }),
        }
      );

      const data = await response.json();
      if (data.subscription) {
        setMessage(
          "Success! Please check your email to confirm your subscription."
        );
        setEmail(""); // Clear input
      } else {
        setMessage(data.message || "Something went wrong.");
      }
    } catch (error) {
      setMessage("Subscription failed. Please try again later.");
      console.error(error);
    }
  };

  const handleEmailClick = () => {
    const email = "contact@toptennis.io";
    const subject = "";
    const body = "";
    const url = `https://mail.google.com/mail/?view=cm&to=${email}&su=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.open(url, "_blank");
  };

  const showFreezeBanner = () => {
    return (
      <div className="freeze-banner">
        <p>{freezeMessage}</p>
      </div>
    );
  };
  const fetchMarketStatus = async () => {
    setIsLoading(true); // Start loader
    try {
      const Token = localStorage.getItem("user_token");
      const response = await axios.get(
        "https://toptennis.io/api/users/market-status",
        { headers: { Authorization: `Bearer ${Token}` } }
      );

      setIsMarketFrozen(response.data.isFrozen);
      setFreezeMessage(response.data.bannerText || "");
      setIsLoading(false);
      // Fetch players only after market status is confirmed
      await fetchPlayersAndMarkSelected();
    } catch (error) {
      console.error("Error fetching market status:", error);
    } finally {
      setIsLoading(false); // Ensure loader stops after API response
    }
  };

  // const fetchMarketStatus = async () => {
  //   try {
  //     const Token = localStorage.getItem("user_token");
  //     const response = await axios.get(
  //       "https://toptennis.io/api/users/market-status",
  //       {
  //         headers: { Authorization: `Bearer ${Token}` },
  //       }
  //     );

  //     // Extract values from the API response
  //     const { isFrozen, bannerText } = response.data;

  //     // Update state with both values
  //     setIsMarketFrozen(isFrozen);
  //     setFreezeMessage(bannerText || ""); // Ensure it's not undefined

  //     // Call these functions after successfully fetching market status
  //     await fetchPlayersAndMarkSelected();
  //   } catch (error) {
  //     console.error("Error fetching market status:", error);
  //   }
  // };

  useEffect(() => {
    fetchMarketStatus();
    showFreezeBanner();
  }, []);

  useEffect(() => {
    // Perform the filtering whenever searchTerm changes
    const lowerCaseSearch = searchTerm.toLowerCase();
    const filtered = players.filter((player) =>
      player.name.toLowerCase().includes(lowerCaseSearch)
    );
    setFilteredPlayers(filtered);
  }, [searchTerm, players]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsPageRefreshed(true);
    }, 1000); // Simulate page refresh after 1 second

    return () => clearTimeout(timer);
  }, []);

  const fetchPlayersAndMarkSelected = async () => {
    const Token = localStorage.getItem("user_token");

    try {
      // Fetch all players
      const playersResponse = await axios.get(
        "https://toptennis.io/api/users/players",
        { headers: { Authorization: `Bearer ${Token}` } }
      );

      // Decode token to get user ID
      const decodedToken = JSON.parse(atob(Token.split(".")[1]));
      const userId = decodedToken._id;

      // Fetch selected team details
      const selectedTeamResponse = await axios.get(
        `https://toptennis.io/api/users/selected-teamlist/${userId}`,
        { headers: { Authorization: `Bearer ${Token}` } }
      );

      // Validate responses
      if (
        playersResponse.data &&
        Array.isArray(playersResponse.data.data) &&
        selectedTeamResponse.data &&
        selectedTeamResponse.data.team
      ) {
        const team = selectedTeamResponse.data.team;
        const teamPlayers = team.players;

        setTeamName(team.name);
        setTeamPlayers(teamPlayers); // Store selected team players
        setBuyPlayer(selectedTeamResponse?.data?.valueDifferences);

        // Set the team profile image
        const baseUrl = "https://toptennis.io/api/images/";
        setTeamProfileImage(`${baseUrl}${team.profile_image}`);

        // Map players
        const allPlayers = playersResponse.data.data.map((player) => {
          const selectedPlayer = teamPlayers.find(
            (teamPlayer) => teamPlayer._id === player._id
          );

          return {
            ...player,
            selected: !!selectedPlayer,
            value: player.value || 0,
          };
        });

        setPlayers(allPlayers);
      }
    } catch (error) {
      console.error("Error fetching players or selected team list:", error);
    }
  };

  useEffect(() => {
    fetchPlayersAndMarkSelected();
  }, []);

  // const fetchUserValues = async () => {
  //   const Token = localStorage.getItem("user_token");

  //   if (Token) {
  //     const decodedToken = JSON.parse(atob(Token.split(".")[1]));
  //     const userId = decodedToken._id;

  //     // Fetch the in-play value from the API
  //     axios
  //       .get(`https://toptennis.io/api/users/user/in-play-value/${userId}`, {
  //         headers: { Authorization: `Bearer ${Token}` },
  //       })
  //       .then((response) => {
  //         // Extract the needed values from the response
  //         const { name, credits, grand_total_value, player_value_sum } =
  //           response.data;

  //         // Set the name, credits, in-play value, and total user player value in state
  //         setUserName(name); // Set the user's name
  //         setCredits(credits); // Set the user's credits
  //         setInPlayValue(grand_total_value); // Set the in-play total value
  //         setTotalSpent(player_value_sum); // Set the total spent value
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching in-play values:", error);
  //       });

  //     // Fetch the overall value from another API (if needed)
  //     axios
  //       .get(`https://toptennis.io/api/users/user/overall/${userId}`, {
  //         headers: { Authorization: `Bearer ${Token}` },
  //       })
  //       .then((response) => {
  //         setOverallValue(response.data.grand_total_value); // Set the overall value
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching overall values:", error);
  //       });
  //   }
  // };

  // useEffect(() => {
  //   fetchUserValues();
  // }, []);

  const fetchUserValues = async () => {
    const Token = localStorage.getItem("user_token");

    if (Token) {
      const decodedToken = JSON.parse(atob(Token.split(".")[1]));
      const userId = decodedToken._id;

      try {
        // Fetch user in-play values
        const response = await axios.get(
          `https://toptennis.io/api/users/user/in-play-value/${userId}`,
          {
            headers: { Authorization: `Bearer ${Token}` },
          }
        );

        const {
          name,
          credits,
          withdrawableCredits,
          grand_total_value,
          player_value_sum,
          differenceValue,
          latest_inc,
          totalDeposit,
        } = response.data;

        setUserName(name);
        setCredits(credits);
        setWithdrawableCredits(withdrawableCredits);
        setInPlayValue(grand_total_value);
        setTotalSpent(player_value_sum);
        setDifferenceValue(differenceValue);
        setplayerval(latest_inc);
        setTotalDeposit(totalDeposit || 0);
      } catch (error) {
        console.error("Error fetching in-play values:", error);
      }
    }
  };

  useEffect(() => {
    fetchUserValues();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsPageRefreshed(true);
    }, 1000); // Simulate page refresh after 1 second

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isPageRefreshed) {
      const token = localStorage.getItem("user_token");
      if (token) {
        try {
          const decodedToken = jwtDecode(token);
          const userId = decodedToken._id;

          axios
            .get("https://toptennis.io/api/users/userList", {
              headers: { Authorization: `Bearer ${token}` },
            })
            .then((response) => {
              const userDetails = response.data.userDetails;
              const matchedUser = userDetails.find(
                (user) => user._id.toString() === userId.toString()
              );

              if (matchedUser) {
                setUserData({
                  fullName: matchedUser.name,
                  credits: matchedUser.credits,
                });
              }
            })
            .catch((error) => console.error("Error fetching user data", error));
        } catch (error) {
          console.error("Failed to decode token", error);
        }
      }
    }
  }, [isPageRefreshed]);

  const handleLogout = () => {
    // Remove the token from localStorage
    localStorage.removeItem("user_token");
    localStorage.removeItem("fullName");
    localStorage.removeItem("userId");
    localStorage.removeItem("user_isfrozen");
    localStorage.removeItem("email");
    // localStorage.removeItem("admin_token");
    // localStorage.removeItem("admin_id");

    // Additional logout logic if needed
    console.log("User logged out successfully.");
    navigate("/"); // Redirect to the login page
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className="container">
      {isLoading && (
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}
      <>
        <div className="card" style={{ background: "none" }}>
          <div className="card-header">
            <div className="market-banner">
              <p>{showFreezeBanner()} </p>
            </div>

            <div className="d-flex2 user-info">
              <button
                variant="light"
                className="d-md-none menu-btn ms-2"
                onClick={handleShow}
              >
                ☰ {/* Hamburger Icon */}
              </button>
              {/* Left Section (Welcome + Navigation) */}
              <div className="left-section5 d-flex1">
                <span className="welcome-text">
                  Welcome, {userData.fullName}
                </span>

                {/* Desktop Navigation */}
                <div className="top-navigation d-none d-md-flex">
                  <span className="nav-item active">Home</span>
                  <span
                    className="nav-item"
                    onClick={() => navigate("/profile")}
                  >
                    Profile
                  </span>
                  <span
                    className="nav-item"
                    onClick={() => navigate("/myteam")}
                  >
                    My Team
                  </span>
                  <span className="nav-item" onClick={() => navigate("/faq")}>
                    FAQs
                  </span>
                  <span className="nav-item" onClick={() => navigate("/news")}>
                    News
                  </span>
                  <span className="nav-item" onClick={handleLogout}>
                    Logout
                  </span>
                </div>

                {/* Mobile Menu (Offcanvas Toggle) */}
              </div>

              {/* Offcanvas (Mobile Menu) */}
              <Offcanvas show={show} onHide={handleClose} placement="start">
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title>Menu</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <div className="mobile-nav">
                    <span className="nav-item active" onClick={handleClose}>
                      Home
                    </span>
                    <span
                      className="nav-item"
                      onClick={() => {
                        navigate("/profile");
                        handleClose();
                      }}
                    >
                      Profile
                    </span>
                    <span
                      className="nav-item"
                      onClick={() => {
                        navigate("/myteam");
                        handleClose();
                      }}
                    >
                      My Team
                    </span>
                    <span
                      className="nav-item"
                      onClick={() => {
                        navigate("/faq");
                        handleClose();
                      }}
                    >
                      FAQs
                    </span>
                    <span
                      className="nav-item"
                      onClick={() => navigate("/news")}
                    >
                      News
                    </span>
                    <span
                      className="nav-item"
                      onClick={() => {
                        navigate("/");
                        handleClose();
                      }}
                    >
                      Logout
                    </span>
                  </div>
                </Offcanvas.Body>
              </Offcanvas>
              <div className="right-section1">
                <div className="credit-box-container">
                  <button
                    className="topup-button"
                    onClick={() => {
                      navigate("/topup");
                    }}
                  >
                    Top-up
                  </button>
                  <div className="credit-box">
                    <p className="p">
                      Credit available: <span>{format2(credits + withdrawableCredits)}</span>
                    </p>
                    <p className="p">
                      Withdrawable Credit: <span>{format2(withdrawableCredits)}</span>
                    </p>
                    <p className="p">
                      In-play: <span>{inPlayValue.toFixed(2)}</span>
                    </p>
                    <p className="p">
                      Current Team P/L:&nbsp;
                      <span
                        style={{
                          color:
                            Number(differenceValue) > 0
                              ? "green"
                              : Number(differenceValue) < 0
                              ? "red"
                              : "black",
                        }}
                      >
                        {differenceValue
                          ? Number(differenceValue) > 0
                            ? `+${Number(differenceValue).toFixed(2)}`
                            : Number(differenceValue).toFixed(2)
                          : "0.00"}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-bodyyy center-container">
            <div className="body-div">
              {/* My Profile (Left Icon) */}
              <div className="profile-icon">
                <img
                  src={image1}
                  alt="profile"
                  className="icon-img"
                  onClick={() => navigate("/profile")}
                />
              </div>

              {/* My Team (Center Icon) */}
              <div className="team-icon">
                <img
                  src={image2}
                  alt="team"
                  className="icon-img"
                  onClick={() => navigate("/myteam")}
                />
              </div>

              {/* User Guide (Right Icon) */}
              <div className="guide-icon">
                <img
                  src={image4}
                  alt="faq"
                  className="icon-img"
                  onClick={() => navigate("/faq")}
                />
              </div>
            </div>
          </div>

          {/* <div className="card-footer">
            <div className="footer">
              <div className="footer-first">
                {!teamPlayers.length && (
                  <button className="btn3" onClick={() => navigate("/myteam")}>
                    Start Building Your Team
                  </button>

                )}
              </div>
              <div className="d-flex2">
                <div className="first">
                  <h5 className="first-h5">{filteredPlayers.filter((p) => p.selected).length}/8</h5>
                  <p className="p1">Selections</p>
                  <p className="p1">{totalSpent.toFixed(2)} spent</p>
                </div>
                <div className="second2">
                  {[...Array(8)].map((_, index) => (
                    <div
                      key={index}
                      className="circle2"
                      style={{
                        backgroundColor:
                          index < filteredPlayers.filter((p) => p.selected).length
                            ? "green"
                            : "red",
                      }}
                    ></div>
                  ))}
                </div>
              </div>
            </div>
          </div> */}
          <div className="card-footer">
            <div className="footer">
              <div className="footer-first">
                {/* <button className="btn3" onClick={() => navigate("/myteam")}>Start Building Your Team</button> */}
                {!teamPlayers.length && (
                  <button className="btn3" onClick={() => navigate("/myteam")}>
                    Start Building Your Team
                  </button>
                )}
              </div>
              <div className="d-flex">
                <div className="first1">
                  <h5 className="first-h5">
                    {filteredPlayers.filter((p) => p.selected).length}/8
                  </h5>
                  <p className="p1">selections</p>
                  <p className="p1">{totalSpent.toFixed(2)} spent</p>
                </div>
                <div className="second2">
                  {[...Array(8)].map((_, index) => (
                    <div
                      key={index}
                      className="circle2"
                      style={{
                        backgroundColor:
                          index <
                          filteredPlayers.filter((p) => p.selected).length
                            ? "green"
                            : "red",
                      }}
                    ></div>
                  ))}
                </div>
              </div>

              <div className="footer-line"></div>

              <div className="footer-firstline">
                <div className="footer-sub">
                  <h4>Keep in touch</h4>
                  <h5>Join our newsletter. We promise not to spam!</h5>
                  <input
                    type="email"
                    placeholder="Email Address"
                    className="footer-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <button className="subscribe-btn" onClick={handleSubscribe}>
                    Subscribe
                  </button>
                  {message && (
                    <p style={{ marginTop: "10px", marginLeft: "5px" }}>
                      {message}
                    </p>
                  )}
                </div>

                <div className="footer-sub1">
                  <h4>Quick links</h4>
                  <a href="/home" className="footer-link">
                    Home
                  </a>
                  <a href="/profile" className="footer-link">
                    Profile
                  </a>
                  <a href="/myteam" className="footer-link">
                    My Team
                  </a>
                  <a href="/news" className="footer-link">
                    News
                  </a>
                  <a href="/faq" className="footer-link">
                    FAQs
                  </a>
                  {/* <a
                    onClick={handleEmailClick}
                    className="footer-link"
                    style={{ cursor: "pointer" }}
                  >
                    Support
                  </a> */}
                </div>

                <div className="footer-sub1 secondicon">
                  <h4>Socials</h4>
                  <div className="social-icons">
                    <a
                      href="https://www.facebook.com/toptennisio/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-circle"
                      style={{ textDecoration: "none" }}
                    >
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a
                      href="https://www.instagram.com/toptennisuk"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-circle"
                      style={{ textDecoration: "none" }}
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                  </div>
                  <div className="fl1">
                    <a
                      href="/terms"
                      className="footer-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      T&Cs
                    </a>
                    <a
                      href="/privacy"
                      className="footer-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Privacy Policy
                    </a>
                    <span className="footer-link">
                      Email: contact@toptennis.io
                    </span>
                  </div>
                </div>

                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
}

export default HomeScreen;
